import { Box, LinearProgress, Paper } from '@mui/material';
import { SelectOption } from 'generated/graphql';
import SearchResultsPanel from './SearchResultsPanel';

const INLINE_RESULTS_MAX_HEIGHT = '400px';

const InlineSearchResults = ({
  inputValue,
  filteredOptions,
  isFetching = false,
  isDisabled = false,
  hasNextPage = false,
  isFetchingMore = false,
  loadMoreIndex,
  height,
  onResultClick,
  onAdd,
  onLoadMore = () => {},
}: {
  inputValue: string;
  filteredOptions: SelectOption[];
  isFetching?: boolean;
  isDisabled?: boolean;
  hasNextPage?: boolean;
  isFetchingMore?: boolean;
  loadMoreIndex?: number;
  height?: number;
  onResultClick: (option: string, optionEntityID: string) => void;
  onAdd?: () => void;
  onLoadMore?: () => void;
}) => {
  if (!inputValue || isDisabled) return null;

  return (
    <Paper
      variant="outlined"
      sx={{
        position: 'relative',
        overflow: 'hidden',
        mt: 1,
        ...(height && { maxHeight: height, display: 'flex', flexDirection: 'column' }),
      }}
    >
      <Box sx={{ position: 'absolute', top: 0, left: 0, right: 0, zIndex: 1, height: 3 }} aria-live="polite">
        {isFetching && <LinearProgress aria-label="Searching" />}
      </Box>
      <SearchResultsPanel
        inputValue={inputValue}
        filteredOptions={filteredOptions}
        isFetching={isFetching}
        hasNextPage={hasNextPage}
        isFetchingMore={isFetchingMore}
        loadMoreIndex={loadMoreIndex}
        maxHeight={height ? undefined : INLINE_RESULTS_MAX_HEIGHT}
        isFilling={!!height}
        isAddPinned
        onResultClick={onResultClick}
        onAdd={onAdd}
        onLoadMore={onLoadMore}
      />
    </Paper>
  );
};

export default InlineSearchResults;
